import styled, { css } from 'styled-components';
import { StyledTextLabel } from '../../../../ui/Input/styled';

export const InputWrapper = styled.div<{ isError: boolean }>`
  background-color: ${({ theme }) => theme.colors.background.tertiary};
  border: 1px solid ${({ theme }) => theme.colors.border.secondary};
  border-radius: 14px;
  padding: 0 15px;
  height: 54px;

  &:focus-within {
    border-color: ${({ theme }) => theme.colors.systemColors.blue};
    background-color: ${({ theme }) => theme.colors.background.primary};
  }

  ${({ isError }) =>
    isError &&
    css`
      border-color: ${({ theme }) => theme.colors.systemColors.red};
    `}

  ${StyledTextLabel} {
    ${({ isError, theme }) =>
      isError &&
      css`
        color: ${theme.colors.systemColors.red};

        path {
          fill: ${theme.colors.systemColors.red};
        }
      `}
  }

  > div:first-child {
    height: 54px;
  }

  input {
    height: 54px;
    padding-top: 24px;

    &:disabled {
      opacity: 1;
    }

    &:-webkit-autofill {
      -webkit-box-shadow: 0 0 0 1000px transparent inset;
      -webkit-text-fill-color: ${({ theme }) => theme.colors.text.primary};
      transition:
        background-color 9999s ease-out,
        color 9999s ease-out;
    }
  }
`;
